import { useEffect } from 'react'

const useOnMount = (fn: () => void): void => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(fn, [])
}

export default useOnMount
